import React, {FC} from 'react';
import {SetStatePropsType} from "@baseTypes/base";
import {SxType} from "@baseTypes/sx/sxTypes";
import Stack from '@mui/material/Stack';
import MuiDatePicker from "./MuiDatePicker";
import {MuiPickerViewType} from "@ui/datePicker/muiDatePicker/types";
import {useTranslation} from 'react-i18next';
import DateStartEndTemplate from "@ui/datePicker/containers/template/dateStartEndTemplate/DateStartEndTemplate";
import DateStartEndTemplateChips
    from "@ui/datePicker/containers/template/dateStartEndTemplateChips/DateStartEndTemplateChips";
import {Typography} from '@mui/material';
import {sx} from './sx'
import TimeSvg from "@resource/svg/TimeSvg";

interface IProps {
    dateStart: string,
    dateEnd: string,
    onChangeDateStart: SetStatePropsType<string>,
    onChangeDateEnd: SetStatePropsType<string>,
    disabled?: boolean,
    format?: string,
    sx?: SxType,
    views?: MuiPickerViewType[],
    showLabel?: boolean
    fullWidth?: boolean,
    inputFormat?: string
    hasTime?: boolean,
    hideTemplate?: boolean,
    sxContainer?:SxType
    children?:React.ReactNode
    inlineTemplateKeys?: string[]
}

const MuiDatePickerDateStartEndSidebar: FC<IProps> = ({
                                                          dateStart,
                                                          dateEnd,
                                                          onChangeDateStart,
                                                          onChangeDateEnd,
                                                          format,
                                                          views,
                                                          disabled,
                                                          showLabel = true,
                                                          fullWidth=true,
                                                          inputFormat,
                                                          hasTime,
                                                          hideTemplate,
                                                          sxContainer={},
                                                          children,
                                                          inlineTemplateKeys,
                                                      }) => {

    const {t} = useTranslation()

    return (
        <Stack
            direction={'row'}
            flexWrap={'wrap'}
            sx={{
                ...sx.root,
                width:fullWidth ? '100%' : 'initial',
                ...sxContainer
            }}
            alignItems={'flex-end'}
            gap={'6px'}
        >
            {!hideTemplate &&  <Stack
                direction={'row'}
                flexWrap={'wrap'}
                sx={sx.inner}
                justifyContent={'space-between'}
            >
                {showLabel && <Stack
                    gap={'3px'}
                    direction={'row'}
                    alignItems={'center'}
                >
                    <TimeSvg/>

                    <Typography
                        sx={sx.label}
                        variant={'body2'}
                    >
                        {t('base.timeInterval')}
                    </Typography>

                </Stack>}

                {!inlineTemplateKeys?.length && <DateStartEndTemplate
                    dateStart={dateStart}
                    onChangeDateStart={onChangeDateStart}
                    dateEnd={dateStart}
                    onChangeDateEnd={onChangeDateEnd}
                    format={format}
                    disabled={disabled}

                />}

                {!!inlineTemplateKeys?.length && <DateStartEndTemplateChips
                    dateStart={dateStart}
                    dateEnd={dateEnd}
                    onChangeDateStart={onChangeDateStart}
                    onChangeDateEnd={onChangeDateEnd}
                    format={format}
                    disabled={disabled}
                    actionKeys={inlineTemplateKeys}
                />}
            </Stack>}

            <MuiDatePicker
                value={dateStart}
                onChange={onChangeDateStart}
                views={views}
                direction={inlineTemplateKeys?.length ? 'row' : undefined}
                alignItems={inlineTemplateKeys?.length ? 'center' : undefined}
                sx={inlineTemplateKeys?.length ? sx.inlineLabel : undefined}
                label={showLabel ? t('base.from') : undefined}
                format={format}
                disabled={disabled}
                fullWidth={fullWidth}
                inputFormat={inputFormat}
                hasTime={hasTime}
            />
            <MuiDatePicker
                value={dateEnd}
                onChange={onChangeDateEnd}
                views={views}
                direction={inlineTemplateKeys?.length ? 'row' : undefined}
                alignItems={inlineTemplateKeys?.length ? 'center' : undefined}
                sx={inlineTemplateKeys?.length ? sx.inlineLabel : undefined}
                label={showLabel ? t('base.to') : undefined}
                format={format}
                disabled={disabled}
                fullWidth={fullWidth}
                inputFormat={inputFormat}
                hasTime={hasTime}
            />
            
            {children && children}
        </Stack>
    );
};

export default MuiDatePickerDateStartEndSidebar;